import React from "react";
import ReactDOM from "react-dom";
import {Link} from "react-router-dom"
function TopMenu() {
    return (
        <div>
            <section className="w3l-top-menu-1">
                <div className="top-hd">
                    <div className="container">
                            <header className="row top-menu-top">
                                <div className="accounts col-md-9 col-6">
                                        <li className="top_li"><span className="fa fa-phone"></span><a href="tel:(214) 244-4423">+1  (214) 244-4423</a> </li>
                                        <li className="top_li1"><span className="fa fa-envelope-o"></span> <a href="mailto:education-mail@support.com" className="mail"> info@lydiapainting.com</a>	</li>
                                </div>
                                <div className="accounts col-md-1 col-3">
                                        <li id="lang-switcher">
                                            <a className="dropdown-toggle" data-toggle="dropdown" href="#">Location</a>
                                            <ul className="dropdown-menu" >
                                                <li><Link to="contact">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;Dallas</Link></li>
                                                <li><Link to="contact">Austin</Link></li>
                                                <li><Link to="contact">Houston</Link></li>
                                                <li><Link to="contact">Antonio</Link></li>
                                                <li><Link to="contact">Texas City</Link></li>
                                                
                                            </ul>
                                        </li>
                                </div>
                                
                                <div className="social-top col-md-2 col-3">
                                    {/* <a href="contact.html" className="btn btn-secondary btn-theme4"></a> */}
                                    
                                    <Link to="/Career" className="btn btn-secondary btn-theme4" >Careers</Link>
                                    
                                </div>
                                
                            </header>
                     </div>
                </div>
            </section>
        </div>
    )
}

export default TopMenu
